import { IMenuItemDb } from "@dining/api-client";
import { Input, makeStyles, Subtitle1 } from "@fluentui/react-components";
import { SearchRegular } from "@fluentui/react-icons";
import * as React from "react";
import { useSelector } from "react-redux";
import { stationItemBankSelector, stationSelector } from "../../selectors/diningSelector";
import AddItemPanel from "../AddItem/AddItemPanel";
import { ItemList } from "./ItemList";

/* ------------------ STYLES ------------------ */

const useStyles = makeStyles({
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  searchBox: {
    width: "100%",
  },
});

/* ------------------ COMPONENT ------------------ */

export const FiltrableMenuItemBank: React.FC = () => {
  const classes = useStyles();

  const selectedStation = useSelector(stationSelector);
  const stationName = selectedStation?.name || "Select a station on the left to begin.";

  const itemBank = useSelector(stationItemBankSelector);
  const [menuItems, setMenuItems] = React.useState<IMenuItemDb[]>(itemBank);

  React.useEffect(() => {
    setMenuItems(itemBank);
  }, [itemBank]);

  /* ------------------ SEARCH HANDLING ------------------ */

  const onChangeText = (_: React.ChangeEvent<HTMLInputElement>, data: { value: string }) => {
    const text = data.value.trim().toLowerCase();

    text ? setMenuItems(itemBank.filter((i) => i.name.toLowerCase().includes(text))) : setMenuItems(itemBank);
  };

  const searchResults = (items: IMenuItemDb[] | null): string => {
    if (items?.length) {
      return items.length === 1 ? "one search result is found." : `${items.length} search results are found.`;
    }
    return "no search result is found.";
  };

  /* ------------------ RENDER ------------------ */

  return (
    <div className="menuContainer" style={{ height: "500px", gap: "10px" }}>
      {/* Header */}
      <div className={classes.headerRow}>
        <Subtitle1>{stationName}</Subtitle1>
        <AddItemPanel />
      </div>

      {/* Content */}
      {selectedStation && (
        <>
          <Input
            placeholder="Search"
            size="small"
            aria-label={`Search box for menu items, ${searchResults(menuItems)}`}
            onChange={onChangeText}
            className={classes.searchBox}
            contentBefore={<SearchRegular style={{ color: "var(--link-color)" }} />}
          />

          <ItemList itemBank={menuItems} />
        </>
      )}
    </div>
  );
};
